<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
            <template slot="progress">
                <v-progress-linear color="primary" indeterminate></v-progress-linear>
            </template>
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="2">
                        <v-text-field label="Código" v-model="perfil.id_perfil" readonly outlined></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field label="Nome" v-model="perfil.nome" outlined></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-select item-text="text" item-value="value" :items="this.tipoAcessos" v-model="perfil.tipoAcesso" label="Tipo Acesso" outlined></v-select>
                    </v-col>
                </v-row>
                <v-row v-show="this.perfil.id_perfil > 0">
                    <v-col cols=12>
                        <v-data-table :height="this.$store.getters.alturaContent - 550"  hide-default-footer locale="pt-BR" dense fixed-header class="table-item" :items="acessos" :headers="fields" :items-per-page="itensPerPage">
                            <template v-slot:item.ativo="{ item }">
                                <v-simple-checkbox v-model="item.ativo"></v-simple-checkbox>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import metodos from '@/mixins/metodos'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'novoPerfilAcesso',
    props:['mostrar'],
    mixins: [metodos],
    data(){
        return{
            cor: 'primary',
            itensPerPage: 15,
            perfil: {
                id_perfil: 0,
                nome: ""
            },
            acessos: [],
            fields:[
                {text: "Código", value: 'id_item'},
                {text: 'Nome', value: 'nome_item'},
                {text: 'Ativo', value: 'ativo'}
            ],
            tipoAcessos: []
        }
    },

    methods:{
        salvar(){
            if(!this.perfil.id_perfil){
                const url = `${baseApiUrl}/Cadastros/perfis/insert.php`
                if(this.perfil.nome && !this.perfil.id_perfil){
                    axios.post(url, {nome: this.perfil.nome})
                        .then(res => { 
                        if(res.data.codigo == '01'){
                            this.perfil.id_perfil = res.data.id_perfil
                            this.buscaAcessosPerfil(res.data.id_perfil)
                            showSuccess(res.data.mensagem)
                        }else{
                            showError(res.data.mensagem)
                        }
                    })

                }else{
                    showError("Informe o nome do perfil")
                }
                
                
            }else{
                let prf = {
                    id_perfil: this.perfil.id_perfil,
                    nome: this.perfil.nome,
                    acessos: this.acessos
                }
                const url = `${baseApiUrl}/Cadastros/perfis/update.php`
					
                axios.post(url, prf)
                    .then(res => { 
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.fechar()
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }
        },

        fechar(){
            this.perfil = {}
            this.$emit("fechar");
        },

        buscaAcessosPerfil(id){
                const url = `${baseApiUrl}/Cadastros/perfis/readAcessos.php?id=${id}`

				axios.get(url)
                    .then(res => {
                        if(res.data.codigo == "01"){
                            this.acessos = res.data.dados.map(p => {
                                return{
                                    ativo: p.ativo == "1" ? true : false,
                                    id_item: p.id_item,
                                    nome_item: p.nome_item
                                }
                            })
                        }
                    })
                    .catch({showError})
            },
    },
}
</script>

<style scoped>

</style>